module.exports = __webpack_public_path__ + "static/media/M.Tech_Course_Structure.9355a2ba.pdf";